// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"25c9971d","239":"d6e7cc3a","453":"46e4c8fc","553":"7b109b81","977":"20458170"}[chunkId] + ".chunk.js";
};